module.exports = __webpack_public_path__ + "img/ic_200_data.88e46287.png";